
import React from 'react'

const Error = () => {
  return (
   <h1>something went wrong . 404 found</h1>
  )
}

export default Error